import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import { durationOptions, sortOptions } from '../../utils/spaConstants';
import { Button } from 'react-bootstrap';

class ServicesOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDuration: 'Any',
            selectedSort: 'Any',
        };
    }

    durationclosePopup = () => this.refs.sort.closePopup();
    sortclosePopup = () => this.refs.duration.closePopup();

    get DurationTrigger() {
        let { services = {} } = this.props,
            { filter = {} } = services,
            _durationText = filter.selectedDuration || 'Any';
        return (
            <button
                className="button-link gotham-xn-book"
                style={{ color: '#0054a0' }}
                aria-expanded={false}
                aria-label={`Duration - ${_durationText}`}>
                {`  ${_durationText} `}
                <svg
                    role="img"
                    alt="open menu"
                    focusable="false"
                    data-test-id="duration-down-arrow"
                    className="svg-icon svg-icon-down-arrow ">
                    <use xlinkHref="#icon-down-arrow"></use>
                </svg>
            </button>
        );
    }

    get DurationOptions() {
        return (
            <div className="options-overlay">
                <div className="options-overlay-close" onClick={this.onDurationClose}>
                    {`Duration: `}
                    <span className="duration-content">{`  ${this.state.selectedDuration}`}</span>

                    <span className="close-x">
                        <svg
                            role="img"
                            alt="close"
                            focusable="false"
                            className="svg-icon svg-icon-close-x ">
                            {' '}
                            <use
                                xlinkHref="#icon-close-x"
                                data-test-id="duration-pop-up-close"></use>
                        </svg>
                    </span>
                </div>
                <span role="listbox" aria-expanded={true} tabIndex="0">
                    {durationOptions.map((option) => (
                        <button
                            data-test-id="duration-text"
                            onClick={this.onDurationSelect.bind(this, option.label)}
                            className={`filter-benefits-button filter-overlay-button  font-size-p2 gotham-xn-book`}>
                            {' '}
                            {option.label}
                        </button>
                    ))}
                </span>
            </div>
        );
    }

    onDurationSelect(selectedDuration) {
        this.refs.duration.closePopup();
        this.props.actions.filterByDuration(selectedDuration, this.state.selectedSort);
        this.setState({ selectedDuration });
    }

    onDurationClose = () => {
        this.refs.duration.closePopup();
        this.setState({ isDurationOpen: false });
    };

    // Sort

    get SortTrigger() {
        return (
            <button
                className="button-link gotham-xn-book"
                style={{ color: '#0054a0' }}
                aria-expanded={false}
                aria-label={`Sort - ${this.state.selectedSort}`}>
                {`  ${this.state.selectedSort}`}
                <svg
                    alt="open"
                    role="img"
                    focusable="false"
                    data-test-id="sort-arrow-down"
                    className="svg-icon svg-icon-down-arrow">
                    <use xlinkHref="#icon-down-arrow"></use>
                </svg>
            </button>
        );
    }

    get SortOptions() {
        return (
            <div className="options-overlay" data-test-id="sort-pop-up">
                <div className="options-overlay-close" onClick={this.onSortClose}>
                    {`Sort: `}
                    <span className="sort-content">{`  ${this.state.selectedSort}`}</span>
                    <span className="sort-close">
                        <svg
                            alt="close"
                            role="img"
                            focusable="false"
                            className="svg-icon svg-icon-close-x">
                            {' '}
                            <use xlinkHref="#icon-close-x" data-test-id="sort-pop-up-close"></use>
                        </svg>
                    </span>
                </div>
                <span role="listbox" aria-expanded={true} tabIndex="0">
                    {sortOptions.map((option) => (
                        <Button
                            onClick={this.onSortSelect.bind(this, option.label)}
                            data-test-id="sort-text"
                            className={`filter-benefits-button filter-overlay-button  font-size-p2 gotham-xn-medium`}>
                            {' '}
                            {option.label}
                        </Button>
                    ))}
                </span>
            </div>
        );
    }

    onSortSelect(selectedSort) {
        this.refs.sort.closePopup();
        this.props.actions.sortAvailableServices(selectedSort);
        this.setState({ selectedSort });
    }

    onSortClose = () => {
        this.refs.sort.closePopup();
        this.setState({ isSortOpen: false });
    };

    render() {
        return (
            <div className="options-container">
                <div className="services-row  container font-size-p2 gotham-xn-book">
                    <span className="duration-fiter-trigger" data-test-id="duration-heading">
                        {` Duration: `}
                        <Popup
                            ref="duration"
                            onOpen={this.durationclosePopup}
                            open={this.state.isDurationOpen}
                            trigger={this.DurationTrigger}
                            closeOnDocumentClick={true}
                            defaultOpen={false}
                            position="bottom center">
                            <div
                                className="option-duration-container"
                                data-test-id="duration-pop-up">
                                {this.DurationOptions}
                            </div>
                        </Popup>
                    </span>

                    <span className="duration-fiter-trigger" data-test-id="sort">
                        {`Sort: `}
                        <Popup
                            ref="sort"
                            onOpen={this.sortclosePopup}
                            open={this.state.isSortOpen}
                            trigger={this.SortTrigger}
                            closeOnDocumentClick={true}
                            defaultOpen={false}
                            position="bottom center">
                            <div className="option-duration-container">{this.SortOptions}</div>
                        </Popup>
                    </span>
                </div>
            </div>
        );
    }
}

export default ServicesOptions;
